import apiClient from "./apiClient";
import { normalizeApiError } from "../utils/apiError";

function toArray(value) {
  return Array.isArray(value) ? value : [];
}

function extractData(payload) {
  return payload?.data ?? payload;
}

const blContainerService = {
  async getBLContainers(params = {}) {
    try {
      // Remove empty values to avoid sending unusable filters.
      const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
        if (value !== "" && value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {});

      const response = await apiClient.get("/containers", {
        params: cleanParams,
      });

      const payload = response?.data || {};
      const dataRoot = extractData(payload);
      const items = toArray(dataRoot?.data || dataRoot?.items || dataRoot);
      const meta = dataRoot?.meta || payload?.meta || {};

      return {
        items,
        meta: {
          page: Number(meta?.page || cleanParams.page || 1),
          limit: Number(meta?.limit || cleanParams.limit || 10),
          total: Number(meta?.total || meta?.totalItems || items.length || 0),
          totalPages: Number(meta?.totalPages || 1),
        },
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getBLContainerById(id) {
    if (!id) throw new Error("BL Container ID is required");

    try {
      const response = await apiClient.get(`/containers/${id}`);
      const payload = response?.data || {};
      return extractData(payload);
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async createBLContainer(containerData) {
    try {
      const response = await apiClient.post("/containers", containerData);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async updateBLContainer(id, containerData) {
    if (!id) throw new Error("BL Container ID is required");

    try {
      const response = await apiClient.patch(`/containers/${id}`, containerData);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async deleteBLContainer(id) {
    if (!id) throw new Error("BL Container ID is required");

    try {
      const response = await apiClient.delete(`/containers/${id}`);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async bulkUpsertBLContainers(containers) {
    try {
      const response = await apiClient.post("/containers/bulk-upsert", containers);
      return extractData(response?.data || {});
    } catch (error) {
      throw normalizeApiError(error);
    }
  },

  async getActiveBLContainers() {
    try {
      const response = await apiClient.get("/containers/active");
      const payload = response?.data || {};
      const data = extractData(payload);
      return {
        items: toArray(data),
        raw: payload,
      };
    } catch (error) {
      throw normalizeApiError(error);
    }
  },
};

export default blContainerService;
